export default __webpack_public_path__ + "static/media/about01.7e380f47.png";